'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Skeleton = require('../Skeleton');

var _Skeleton2 = _interopRequireDefault(_Skeleton);

var _reactLoadable = require('react-loadable');

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = undefined && undefined.__assign || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var LoadContainer = _styledComponents2.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 2rem;\n  text-align: center;\n"], ["\n  padding: 2rem;\n  text-align: center;\n"])));
var Loading = function Loading() {
    return React.createElement(LoadContainer, { "data-qa": "loader" }, React.createElement(_Skeleton2.default, { active: true }));
};
var LoadablePage = function LoadablePage(options) {
    return (0, _reactLoadable2.default)(__assign({ loading: Loading }, options));
};
exports.default = LoadablePage;

var templateObject_1;
//# sourceMappingURL=LoadablePage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/LoadablePage/LoadablePage.js
// module id = 122
// module chunks = 6